export const RESET_BUTTON_NS = 'components/ResetButton';

export const i18n = {
    en: {
        resetAll: 'Reset All',
        youWillResetAllFilters: 'You will reset all filters',
    },
};
